import { useState } from "react"

import routes from "web/routes/constants"

import Header from "./Header"
import DealAsset from "./DealAsset"

export default function DealAssetLocationCard({
  primarySubject,
  location,
  dealAssets,
  onSelectionChanged,
  onClose,
}) {
  const numberOfAssets = dealAssets.length
  const showToggle = numberOfAssets > 1
  const selectionEnabledInHeader = numberOfAssets === 1

  const [expandedIndex, setExpandedIndex] = useState(0)

  function goToDealAsset(dealAsset) {
    window.Turbo.visit(
      routes.deal_asset("all", null, dealAsset.deal_id, dealAsset.id)
    )
  }

  return (
    <div className="mb-4 min-h-sm w-64 cursor-pointer rounded-md bg-white pb-2 shadow-altrio-1">
      <Header
        title={primarySubject.name}
        location={location}
        primarySubject={primarySubject}
        selectionEnabled={selectionEnabledInHeader}
        onSelectionChanged={onSelectionChanged}
        onClick={() => goToDealAsset(primarySubject)}
        onClose={onClose}
      />
      <div>
        {dealAssets.map((dealAsset, i) => {
          return (
            <DealAsset
              key={i}
              subjectType="deal_asset"
              dealAsset={dealAsset}
              icon="building-office"
              showToggle={showToggle}
              isExpanded={expandedIndex === i}
              selectionEnabled={!selectionEnabledInHeader}
              onToggle={() => setExpandedIndex(i)}
              onClick={() => goToDealAsset(dealAsset)}
              onSelectionChanged={onSelectionChanged}
            />
          )
        })}
      </div>
    </div>
  )
}
